exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yo-btn[data-v-467b7790]{height:100px;background-color:red;color:#fff;font-size:27px;border-radius:20px;text-align:center;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;cursor:pointer;-webkit-box-shadow:0 0 30px 0 #f9acac inset,0 0 30px 0 #f9acac;box-shadow:inset 0 0 30px 0 #f9acac,0 0 30px 0 #f9acac;margin:30px;-webkit-box-sizing:border-box;box-sizing:border-box}", ""]);

// exports
